<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-6 col-lg-6">
                        <div class="font-weight-bold body-1">
                            Editar accesos de empresa
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="6" lg="6">
                        <v-form ref="form" @submit.prevent="save">
                            <business-form ref="BusinessForm" :values="form" @save="save" :serverErrors="serverErrors" :edit="true"></business-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" lg="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../helpers/Utils';
import BusinessForm from "./FormPermissions.vue";
import Object2Form from "../../../helpers/Object2Form";
import permissions from "./permission";
export default {
    components: {
        'business-form': BusinessForm,
    },
	data(){
		return {
            slug: this.$route.params.slug,
            loading: false,
            serverErrors: {},
            form: {
                // name: "",
                // trade_name: "",
                // entry: "",
                // rfc: "",
                menu: permissions,
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Business",
                block:false,	
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar cambios",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        this.index();
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
    },
	methods: {
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        index()
        {
            this.$store.state.loading = true;
            this.loading = true;
            this.$api.business.get(this.slug)
                .then((resp) => {
                    // this.form = resp.data;
                    this.form.menu = {...permissions, ...resp.data.menu};
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.loading = false;
                    this.loading = false;
                })
            ;
        },
        save(){
            
            console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.business.updateMenu(this.slug, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'Business'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },


        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));

            // data.logo_file = request.logo_file;

            // if(request.logo_path == '' && (request.logo_file instanceof Array))
            //     data.logo_file = null;

            // if(request.logo_path != '' && (request.logo_file instanceof Array))
            //     delete data.logo_file;


            // if(data.status)
            //     data.status = 1;
            // else
            //     data.status = 0;

            data.menu = JSON.stringify(data.menu)
    

            return Object2Form.objectToFormData(data, "", []);
        }
    },
}
</script>

<style>

</style>